// Thin ESM re-export of the shared CommonJS module, so the browser and the
// Cloud Functions validate against exactly the same branch/role lists and rules.
// Source of truth: functions/shared/job_ads_options.js
import shared from '../../functions/shared/job_ads_options'

export const {
    JOB_REGIONS,
    JOB_BRANCHES,
    JOB_ROLES,
    SELECTION_KINDS,
    SELECTION_FIELDS,
    QUESTIONS,
    MESSAGES,
    LEGACY_FIELD_DEFAULTS,
    DEFAULT_SELECTION_CONFIG,
    normalizeSelectionConfig,
    normalizeApplyFormConfig,
    sanitizeSelectionConfig,
    uniqueStrings,
    pairKey,
    isPairBlocked,
    groupOf,
    labelOf,
    groupLabelOf,
    getOptionAvailability,
    validateSelection,
    toLabelSnapshot,
    groupedOptions,
    ruleItems
} = shared

export default shared
